export enum SentryFlow {
  ADMIN_LOGIN = "admin_login",
  TOKEN_REQUEST_KRAKEND = "admin_token_request.krakend",
  TOKEN_REQUEST_ONECLICK = "admin_token_request.oneclick",
  TOKEN_APPROVAL_KRAKEND = "admin_token_approval.krakend",
  TOKEN_APPROVAL_ONECLICK = "admin_token_approval.oneclick",
  APPLICATION_REQUEST = "admin_application_request",
  APPLICATION_APPROVAL = "admin_application_approval",
}

export enum AddPermissionWidgetType {
  Page,
  Action,
  Listing,
  Page_Filter,
  Page_Form,
  Listing_Filter,
  Form_Field,
  Listing_Action,
}

export enum CompanyStatus {
  PENDING,
  SALES_APPROVED,
  FINANCIAL_APPROVED,
  FINANCIAL_DENIED,
}

export enum TmsRoadApiStatus {
  UNKNOWN,
  CREATE_IN_PROGRESS,
  UPDATE_IN_PROGRESS,
  ERROR,
  SYNCED,
}
export enum TableType {
  COMPANIES = 0,
  CONTACTS = 1,
  ERP_CUSTOMERS = 2,
  WAREHOUSEING_RECEPTION_RETURN = 3,
  WAREHOUSEING_ORDERS = 4,
  WAREHOUSEING_SIMPLIFY_RECEPTION_RETURN = 5,
  WAREHOUSEING_SIMPLIFY_ORDERS = 6,
  DOMESTIC_ROAD = 7,
  INTERNATIONAL_ROAD = 8,
  OCEAN = 9,
  AIR = 10,
  ERP_CUSTOMERS_INVOICE_OVERVIEW = 11,
  ERP_CUSTOMERS_DOMESTIC_SHIPMENT_OVERVIEW = 12,
  ERP_CUSTOMERS_INTERNATIONAL_SHIPMENT_OVERVIEW = 13,
  COMPANY_USER = 14,
  ERP_CUSTOMERS_SHIPMENT_SEA_OVERVIEW = 15,
  ERP_CUSTOMERS_SHIPMENT_AIR_OVERVIEW = 16,
  API_RESOURCE_FIELD = 17,
  API_ROUTE_FIELD = 18,
  KLG_USERS = 19,
  EXCHANGE_RATES = 20,
  COMPANY_FOR_ALL = 21,
  ACCCOUNT_RECEIVABLES = 22,
  LEGAL_HOLIDAYS = 23,
  STRONGO_SHIPMENTS = 24,
  APP_STATUSES = 25,
  ERP_CUSTOMERS_SHIPMENT_STRONGO_OVERVIEW = 26,
  KRAKEND_TOKENS = 27,
  USER_SESSIONS = 28,
  KLG_USER_SESSIONS = 29,
  ONECLICK_TOKEN_DEMANDS = 30,
  ONECLICK_TOKENS = 31,
  KRAKEND_TOKEN_DEMANDS = 32,
  APPLICATION_DEMANDS = 33,
  APPLICATIONS = 34,
  MCP_TOKENS = 35,
  MCP_TOKEN_ACTIVITIES = 36,
  NOTIFICATIONS = 37,
  ALERTS = 38,
  CLIENT_MCP_TOKENS = 39,
  CLIENT_MCP_TOKEN_ACTIVITIES = 40,
  CLEO_DOCUMENTS = 41,
  APPLICATION_API_RESOURCE_FIELD = 42,
  APPLICATION_API_ROUTE_FIELD = 43,
  CLEO_INSIGHTS = 44,
  ETRANSPORT_DECLARATIONS = 45,
}

export enum CompanyBusinessLineType {
  ROAD_DOMESTIC = 1,
  OCEAN = 2,
  WAREHOUSING_SIMPLIFY = 3,
  WAREHOUSING = 4,
  ERP = 5,
  ROAD_INTERNATIONAL = 6,
  AIR = 7,
  STRONGO = 8,
}

export enum AuthorizedEmailApplication {
  AZURE = 1,
  AZURE_EMAIL = 2,
  AZURE_APP_KLG_USERS = 3,
  SHAREPOINT_CONTRACTS = 4,
  ANAF_ETRANSPORT = 5,
}

export enum CompanyContractAddendumType {
  CLAUSE = 1,
  EXTENSION = 2,
  TERMINATION = 3,
}

export enum CompanyDocumentRenewalType {
  AUTOMATIC = 1,
  MANUAL = 2,
}

export enum CompanyAnnexType {
  TARIFF = "Tariff",
  SERVICE = "Service",
  GDPR = "GDPR",
}

export enum ClientUserType {
  REGULAR = 0,
  API = 1,
}

export enum EtransportStatusType {
  DRAFT = 1,
  SENT = 2,
  VALID = 3,
  REJECTED = 4,
  CORRECTION_PENDING = 5,
  DELETION_PENDING = 6,
  DELETED = 7,
  CONFIRMATION_PENDING = 8,
  CONFIRMED = 9,
  PARTIALLY_CONFIRMED = 10,
  INFIRMED = 11,
  VEHICLE_CHANGE_PENDING = 12,
  EXPIRED = 13,
}

export enum EtransportOperationType {
  INTRA_COMMUNITY_ACQUISITION = 10,
  LOHN_ENTRY = 12,
  CALL_OFF_STOCK_ENTRY = 14,
  INTRA_COMMUNITY_DELIVERY = 20,
  LOHN_EXIT = 22,
  CALL_OFF_STOCK_EXIT = 24,
  NATIONAL_TRANSPORT = 30,
  IMPORT = 40,
  EXPORT = 50,
  WAREHOUSE_ENTRY = 60,
  WAREHOUSE_EXIT = 70,
}

export enum EtransportSubmissionKind {
  NOTIFICATION = "NOT",
  CORRECTION = "COR",
  DELETION = "DEL",
  CONFIRMATION = "CON",
  VEHICLE_CHANGE = "MVH",
}

export enum EtransportAnafState {
  OK = "ok",
  NOK = "nok",
  IN_PROGRESS = "in prelucrare",
  XML_ERRORS = "XML cu erori nepreluat de sistem",
  UPLOAD_REJECTED = "upload_rejected",
}

export enum EtransportConfirmationType {
  CONFIRMED = 10,
  PARTIALLY_CONFIRMED = 20,
  INFIRMED = 30,
}

export enum EtransportLocationType {
  BORDER_CROSSING_POINT = "PTF",
  CUSTOMS_OFFICE = "BV",
  ADDRESS = "ADR",
}

export enum EtransportDocumentType {
  CMR = 10,
  INVOICE = 20,
  DELIVERY_NOTE = 30,
  OTHER = 9999,
}

export enum RoleType {
  FINAL_PERM = 27,
}
